
import { useEffect } from "react";
import Whiteboard from "@/components/Whiteboard";

const Index = () => {
  useEffect(() => {
    console.log("Index component mounted at:", new Date().toLocaleTimeString());
    console.log("Environment mode:", import.meta.env.MODE);
  }, []);
  
  return (
    <div className="w-full h-full overflow-hidden">
      <Whiteboard />
    </div>
  );
};

export default Index;
